import Resource from 'api/resource';
class AnnouncementResource extends Resource {
  constructor() {
    super('feed-post/');
  }
}

export { AnnouncementResource as default };
